import type { SelectOption } from "@/components/basics/Select.vue";

export const findOptionByValue = (value: number, options: SelectOption[]) => options.find((o) => o.value === value);

export const findOptionByLabel = (label: string, options: SelectOption[]) => options.find((o) => o.label === label);
